// Replayable snapshot of a navigation request. Saved in window.history.state
// under the __fractal key so back/forward can reproduce the original request
// verbatim — same URL, same headers, same body — independent of any state
// drift that happened in between. See TNBEWEB-1905.
export type NavContext = {
  kind: 'action';
  url: string;
  method: string;
  headers: Record<string, string>;
  body?: string;
  componentId?: string;
  screenId?: string;
  cacheActionUrl?: string;
  sendAll?: boolean;
};

export type FractalHistoryState = {
  __fractal?: NavContext;
};

const FRACTAL_KEY = '__fractal';

export const getNavContext = (state: unknown): NavContext | undefined => {
  if (!state || typeof state !== 'object') return undefined;
  const maybe = (state as FractalHistoryState)[FRACTAL_KEY];
  return maybe && maybe.kind === 'action' ? maybe : undefined;
};

export const pushNavState = (path: string, ctx: NavContext) => {
  window.history.pushState({ [FRACTAL_KEY]: ctx }, '', path);
};

export const replaceNavState = (ctx: NavContext) => {
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.history.replaceState({ [FRACTAL_KEY]: ctx }, '', currentUrl);
};
